import BaseService from "./BaseService";
import IUserResponse from "../core/contracts/IUserResponse";
import IResetPassword from "../core/contracts/IResetPassword";
import IPushUserToken from "../core/contracts/IPushUserToken";
import { LocalCache } from "../helpers/cache";
import { SCACHE_USER } from "../core/constants/cacheKeys";
import jwt_decode from "jwt-decode";
import { get } from "lodash";
import EUser from "../core/contracts/EUser";

export default class UserService extends BaseService {
  async fetch(): Promise<IUserResponse> {
    try {
      const cache = new LocalCache();
      const cachedUser = cache.get<EUser>(SCACHE_USER);

      if (cachedUser?.codigo) return cache.get(SCACHE_USER) as any;

      const token = cache.get("bearer-token");

      if (token) {
        const decodedToken = jwt_decode(String(token));

        const userInfoStr = get(decodedToken, "user_info", {});

        if (userInfoStr) {
          const userInfo = JSON.parse(userInfoStr);

          cache.set(SCACHE_USER, userInfo);

          return userInfo;
        }
      }

      return {} as any;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("UserService -> fetch -> error", error);
      return Promise.reject(error);
    }
  }

  async resetPassword(mail: IResetPassword): Promise<boolean> {
    try {
      return await new BaseService(true).post<boolean, IResetPassword>(
        "/core/User/resetpassword",
        mail
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("UserService -> resetPassword -> error", error);
      return Promise.reject(error);
    }
  }

  async sendResetPassword(mail: string): Promise<boolean> {
    try {
      return await new BaseService(true).post<boolean, { email: string }>(
        "/core/User/resetpassword",
        { email: mail }
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("UserService -> resetPassword -> error", error);
      return Promise.reject(error);
    }
  }

  async validateResetToken(token: string): Promise<IUserResponse> {
    try {
      return await new BaseService(true).get<IUserResponse>("/core/User/resettoken/" + token);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("UserService -> validateResetToken -> error", error);
      return Promise.reject(error);
    }
  }

  async updatePushToken(pushUserToken: IPushUserToken): Promise<boolean> {
    try {
      return await new BaseService(true).post<boolean, IPushUserToken>(
        "/core/User/updatePushUser",
        pushUserToken
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("UserService -> updatePushUser -> error", error);
      return Promise.reject(error);
    }
  }

  async filterUsers(nameOrEmail: string) {
    if (!nameOrEmail) {
      return Promise.reject("Nenhum nome ou e-mail fornecido!");
    }

    try {
      return new BaseService(true).get(`/User/ListarFiltrados?Filter=${nameOrEmail}`);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn(
        "🚀 ~ file: UserService.ts ~ line 78 ~ UserService ~ filterUsers ~ error",
        error
      );
      return Promise.reject(error);
    }
  }
}
